/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/Edition-Gift-Basket/Edition-Gift-Basket-Modal.ts":
/*!**************************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-Gift-Basket-Modal.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGiftBasketModal)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var EditionGiftBasketModal = /*#__PURE__*/function (_HTMLElement) {
  function EditionGiftBasketModal() {
    var _this;
    _classCallCheck(this, EditionGiftBasketModal);
    _this = _callSuper(this, EditionGiftBasketModal);
    _this.bodyEle = document.querySelector('body');
    _this.modal = document.getElementById('product-modal');
    _this.list = document.getElementById('selected-products');
    _this.products = Array.from(document.querySelectorAll('.product-item'));
    return _this;
  }
  _inherits(EditionGiftBasketModal, _HTMLElement);
  return _createClass(EditionGiftBasketModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      document.addEventListener('productAdded', function () {
        _this2.calculateCosts();
      });
      var filterLinks = Array.from(document.querySelectorAll('[data-filter]'));
      var clearFilterLink = document.getElementById('clear-filter');
      var addToBasketButton = document.getElementById('add-to-basket-button');
      var closeModalButton = document.getElementById('close-modal');
      var finishModalButton = document.getElementById('finish-close-modal');
      var openGiftModal = document.getElementById('open-gift-card-modal');
      var openPackagingModal = document.getElementById('continue_card');
      // Event listeners for opening modals
      openGiftModal.addEventListener('click', function () {
        return _this2.openGiftCardModal();
      });
      openPackagingModal.addEventListener('click', function () {
        return _this2.openPackagingModal();
      });
      // Event listeners for filters
      filterLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent default link behavior
          _this2.handleFilterClick(link);
        });
      });
      // Select the first filter by default and show its products
      var firstFilterLink = filterLinks[0];
      if (firstFilterLink) {
        this.handleFilterClick(firstFilterLink);
      }
      // Event listeners for modals and buttons
      addToBasketButton === null || addToBasketButton === void 0 ? void 0 : addToBasketButton.addEventListener('click', function () {
        return _this2.openModal();
      });
      closeModalButton.addEventListener('click', function () {
        return _this2.closeModal();
      });
      finishModalButton.addEventListener('click', function () {
        return _this2.closeModal();
      });
      window.addEventListener('click', function (e) {
        if (e.target === _this2.modal) {
          _this2.closeModal();
        }
      });
      window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          _this2.closeModal();
        }
      });
      // Load products from local storage
      setTimeout(function () {
        _this2.loadProductsFromLocalStorage();
      }, 1000);
      document.addEventListener('giftCardSelected', function (e) {
        var _e$detail = e.detail,
          variantId = _e$detail.variantId,
          imgSrc = _e$detail.imgSrc,
          price = _e$detail.price,
          title = _e$detail.title,
          quantity = _e$detail.quantity,
          isGiftCard = _e$detail.isGiftCard,
          isPackaging = _e$detail.isPackaging;
        _this2.addGiftCardToSelectedProducts(variantId, imgSrc, price, title, quantity, isGiftCard, isPackaging);
      });
      document.addEventListener('packagingSelected', function (e) {
        var _e$detail2 = e.detail,
          variantId = _e$detail2.variantId,
          imgSrc = _e$detail2.imgSrc,
          price = _e$detail2.price,
          title = _e$detail2.title,
          quantity = _e$detail2.quantity,
          isGiftCard = _e$detail2.isGiftCard,
          isPackaging = _e$detail2.isPackaging;
        _this2.addPackagingToSelectedProducts(variantId, imgSrc, price, title, quantity, isGiftCard, isPackaging);
      });
    }
  }, {
    key: "openGiftCardModal",
    value: function openGiftCardModal() {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      if (!selectedProducts || selectedProducts.length === 0) {
        alert('Tilføj et produkt til gavekurven for at fortsætte.');
        return;
      }
      var giftCardModal = document.getElementById('gift_card_modal');
      giftCardModal.classList.remove('tw-hidden');
      this.bodyEle.classList.add('body_no_scroll');
    }
  }, {
    key: "openPackagingModal",
    value: function openPackagingModal() {
      var packagingModal = document.getElementById('packaging_modal');
      var openGiftModal = document.getElementById('open-gift-card-modal');
      openGiftModal.classList.add('tw-hidden');
      packagingModal.classList.remove('tw-hidden');
      this.bodyEle.classList.add('body_no_scroll');
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modal.classList.add('tw-hidden');
      this.bodyEle.classList.remove('body_no_scroll');
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modal.classList.remove('tw-hidden');
      this.bodyEle.classList.add('body_no_scroll');
    }
  }, {
    key: "handleFilterClick",
    value: function handleFilterClick(link) {
      var filter = link.getAttribute('data-filter');
      // Remove 'tw-underline' and 'active' from all filter links
      var filterLinks = document.querySelectorAll('[data-filter]');
      filterLinks.forEach(function (filterLink) {
        filterLink.classList.remove('tw-underline', 'active');
      });
      // Add 'tw-underline' and 'active' to the clicked filter
      link.classList.add('!tw-underline', 'active');
      // Hide all product lists
      var productLists = document.querySelectorAll('.product-list');
      productLists.forEach(function (list) {
        list.style.display = 'none';
      });
      // Show the selected product list
      var selectedProductList = document.querySelector(".product-list[data-filter=\"".concat(filter, "\"]"));
      if (selectedProductList) {
        selectedProductList.style.display = 'grid'; // or 'block' based on your layout
      }
    }
  }, {
    key: "loadProductsFromLocalStorage",
    value: function loadProductsFromLocalStorage() {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      selectedProducts.forEach(function (product) {
        var id = product.variantId;
        var quantity = Number(product.quantity);
        var productOnList = document.querySelector("edition-gift-product[data-variantid=\"".concat(id, "\"]"));
        if (productOnList) {
          var quantityUpSelectorForProduct = productOnList.querySelector('.increment');
          for (var i = 0; i < quantity; i++) {
            quantityUpSelectorForProduct.click();
          }
        }
      });
    }
  }, {
    key: "calculateCosts",
    value: function calculateCosts() {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      var totalPriceMoneyEle = document.getElementById('total-price');
      var totalPriceExMoneyEle = document.getElementById('total-price-ex-tax');
      var totalPrice = 0;
      if (!selectedProducts || selectedProducts.length === 0) {
        totalPriceMoneyEle.textContent = '0,00 kr.';
        totalPriceExMoneyEle.textContent = '0,00 kr.';
        return;
      }
      selectedProducts.forEach(function (product) {
        var price = Number(product.price.replace(/[^0-9,-]+/g, '').replace(',', '.'));
        var quantity = Number(product.quantity);
        totalPrice += price * quantity;
      });
      var price = totalPrice;
      var priceNoTax = price * 0.8;
      totalPriceMoneyEle.textContent = price.toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
      totalPriceExMoneyEle.textContent = priceNoTax.toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
    }
  }, {
    key: "addGiftCardToSelectedProducts",
    value: function addGiftCardToSelectedProducts(variantId, imgSrc, price, title, quantity) {
      var isGiftCard = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
      var isPackaging = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      this.addProductToSelected(variantId, imgSrc, price, title, quantity, isGiftCard, isPackaging);
    }
  }, {
    key: "addPackagingToSelectedProducts",
    value: function addPackagingToSelectedProducts(variantId, imgSrc, price, title, quantity) {
      var isGiftCard = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var isPackaging = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
      this.addProductToSelected(variantId, imgSrc, price, title, quantity, isGiftCard, isPackaging);
    }
  }, {
    key: "addProductToSelected",
    value: function addProductToSelected(variantId, imgSrc, price, title, quantity, isGiftCard, isPackaging) {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      var existingProductIndex = selectedProducts.findIndex(function (product) {
        return product.variantId === variantId;
      });
      if (existingProductIndex === -1) {
        selectedProducts.push({
          variantId: variantId,
          imgSrc: imgSrc,
          price: price,
          title: title,
          quantity: quantity,
          isGiftCard: isGiftCard,
          isPackaging: isPackaging
        });
      } else {
        selectedProducts[existingProductIndex].quantity += quantity;
      }
      localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
      this.calculateCosts();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/Edition-Gift-Basket/Edition-Gift-Card-Modal.ts":
/*!************************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-Gift-Card-Modal.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditiongiftCardModal)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var EditiongiftCardModal = /*#__PURE__*/function (_HTMLElement) {
  function EditiongiftCardModal() {
    var _this;
    _classCallCheck(this, EditiongiftCardModal);
    _this = _callSuper(this, EditiongiftCardModal);
    _this.selectedVariantId = null;
    _this.selectedVariantDetails = {};
    _this.giftCardModal = document.getElementById('gift_card_modal');
    _this.continueButton = document.getElementById('continue_card');
    _this.clearButton = document.getElementById('gift-bakset-clear');
    _this.giftCardMessageBtns = Array.from(document.querySelectorAll('.gift-card-massage-btn'));
    _this.giftCardMessageContainer = document.querySelector('.gift-card-message-container');
    _this.giftCardMessageSaveBtn = document.querySelector('.gift-card-message-save');
    return _this;
  }
  _inherits(EditiongiftCardModal, _HTMLElement);
  return _createClass(EditiongiftCardModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initializeProductItems();
      this.giftCardMessageBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var savedmassage = localStorage.getItem('giftCardMessage') || '';
          if (savedmassage) {
            var giftCartMessageTextArea = document.querySelector('.gift-card-message');
            giftCartMessageTextArea.value = savedmassage;
          }
          _this2.giftCardMessageContainer.classList.toggle('active');
        });
      });
      this.giftCardMessageSaveBtn.addEventListener('click', function () {
        _this2.giftCardMessageContainer.classList.toggle('active');
      });
      this.continueButton.addEventListener('click', function () {
        var giftCartMessageTextArea = document.querySelector('.gift-card-message');
        if (giftCartMessageTextArea.value.trim()) {
          localStorage.setItem('giftCardMessage', giftCartMessageTextArea.value.trim());
        }
        if (_this2.selectedVariantId) {
          var formattedPrice = (_this2.selectedVariantDetails.price / 100).toLocaleString('da-DK', {
            style: 'currency',
            currency: 'DKK'
          });
          var eventDetail = {
            variantId: _this2.selectedVariantId,
            imgSrc: _this2.selectedVariantDetails.imgSrc || '',
            price: formattedPrice,
            isGiftCard: true,
            isPackaging: false,
            title: _this2.selectedVariantDetails.title || '',
            quantity: 1
          };
          _this2.dispatchEvent(new CustomEvent('giftCardSelected', {
            detail: eventDetail,
            bubbles: true,
            composed: true
          }));
        }
      });
      this.clearButton.addEventListener('click', function () {
        _this2.clearSelection();
      });
    }
  }, {
    key: "initializeProductItems",
    value: function initializeProductItems() {
      var _this3 = this;
      var productItems = this.querySelectorAll('.gift-card-item');
      productItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var _a;
          if (item.classList.contains('cc-selected-variant')) {
            item.classList.remove('cc-selected-variant');
            _this3.selectedVariantId = null;
            _this3.selectedVariantDetails = {};
          } else {
            productItems.forEach(function (i) {
              return i.classList.remove('cc-selected-variant');
            });
            item.classList.add('cc-selected-variant');
            _this3.selectedVariantId = item.getAttribute('data-variantid');
            _this3.selectedVariantDetails = {
              imgSrc: ((_a = item.querySelector('img')) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) || '',
              price: parseFloat(item.getAttribute('data-price') || '0'),
              title: item.getAttribute('data-title') || ''
            };
          }
          _this3.handleVariantSelection(_this3.selectedVariantId);
        });
      });
    }
  }, {
    key: "handleVariantSelection",
    value: function handleVariantSelection(variantId) {
      if (variantId) {
        this.continueButton.textContent = 'Fortsæt';
        this.clearButton.classList.remove('tw-hidden');
      } else {
        this.continueButton.textContent = 'Fortsæt uden kort';
        this.clearButton.classList.add('tw-hidden');
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var productItems = this.querySelectorAll('.gift-card-item');
      productItems.forEach(function (item) {
        return item.classList.remove('cc-selected-variant');
      });
      this.selectedVariantId = null;
      this.selectedVariantDetails = {};
      this.handleVariantSelection(null);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/Edition-Gift-Basket/Edition-Gift-Product.ts":
/*!*********************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-Gift-Product.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGiftProduct)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var EditionGiftProduct = /*#__PURE__*/function (_HTMLElement) {
  function EditionGiftProduct() {
    var _this;
    _classCallCheck(this, EditionGiftProduct);
    _this = _callSuper(this, EditionGiftProduct);
    _this.giftQuantity = _this.querySelector('.gift_quantity');
    _this.dataQuantity = _this.giftQuantity.getAttribute('data-quantity') || '0';
    _this.list = document.getElementById('selected-products');
    _this.addToCartButton = document.getElementById('add-to-cart-modal');
    _this.bodyEle = document.querySelector('body');
    _this.isAddToCartButtonListenerAdded = false;
    _this.giftCardMessageContainer = document.querySelector('.gift-card-message-container');
    _this.giftCardMessageSaveBtn = document.querySelector('.gift-card-message-save');
    return _this;
  }
  _inherits(EditionGiftProduct, _HTMLElement);
  return _createClass(EditionGiftProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.loadSelectedProductsFromLocalStorage();
      this.hideProductsWithMaxZero();
      this.initializeEventListeners();
      this.listenForGiftCardSelection();
      this.listenForPackagingSelection();
      this.handleProductReadMoreAddToBasket();
    }
  }, {
    key: "loadSelectedProductsFromLocalStorage",
    value: function loadSelectedProductsFromLocalStorage() {
      var _this2 = this;
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      selectedProducts.forEach(function (product) {
        _this2.renderElementOnList(product.quantity, product.variantId, product.imgSrc, product.price, product.title, product.isGiftCard, product.isPackaging);
      });
      this.toggleModalsBasedOnPackaging();
    }
  }, {
    key: "hideProductsWithMaxZero",
    value: function hideProductsWithMaxZero() {
      var products = this.querySelectorAll('.quantity__button');
      products.forEach(function (btn) {
        var max = Number(btn.dataset.max);
        if (max === 0) {
          btn.closest('.product-item').style.display = 'none';
        }
      });
    }
  }, {
    key: "initializeEventListeners",
    value: function initializeEventListeners() {
      var _this3 = this;
      var quantitySelectors = Array.from(this.querySelectorAll('.quantity__button'));
      quantitySelectors.forEach(function (btn) {
        btn.addEventListener('click', function () {
          _this3.handleQuantityChange(btn);
        });
      });
      var readMoreBtn = this.querySelector('.read-more');
      readMoreBtn === null || readMoreBtn === void 0 ? void 0 : readMoreBtn.addEventListener('click', function (e) {
        _this3.handleProductReadMore();
      });
      var readMoreCloseBtn = this.querySelector('.read-more-close');
      readMoreCloseBtn === null || readMoreCloseBtn === void 0 ? void 0 : readMoreCloseBtn.addEventListener('click', function (e) {
        _this3.handleProductReadMore();
      });
    }
  }, {
    key: "listenForGiftCardSelection",
    value: function listenForGiftCardSelection() {
      var _this4 = this;
      document.addEventListener('giftCardSelected', function (event) {
        var _event$detail = event.detail,
          variantId = _event$detail.variantId,
          imgSrc = _event$detail.imgSrc,
          price = _event$detail.price,
          title = _event$detail.title,
          quantity = _event$detail.quantity,
          isGiftCard = _event$detail.isGiftCard,
          isPackaging = _event$detail.isPackaging;
        _this4.renderElementOnList(quantity, variantId, imgSrc, price, title, isGiftCard, isPackaging);
      });
    }
  }, {
    key: "listenForPackagingSelection",
    value: function listenForPackagingSelection() {
      var _this5 = this;
      document.addEventListener('packagingSelected', function (event) {
        var _event$detail2 = event.detail,
          variantId = _event$detail2.variantId,
          imgSrc = _event$detail2.imgSrc,
          price = _event$detail2.price,
          title = _event$detail2.title,
          quantity = _event$detail2.quantity,
          isGiftCard = _event$detail2.isGiftCard,
          isPackaging = _event$detail2.isPackaging;
        _this5.renderElementOnList(quantity, variantId, imgSrc, price, title, isGiftCard, isPackaging);
      });
    }
  }, {
    key: "handleQuantityChange",
    value: function handleQuantityChange(btn) {
      var max = Number(btn.dataset.max);
      if (max === 0) {
        return;
      }
      var quantity = Number(this.giftQuantity.textContent);
      var imgSrc = btn.dataset.imgsrc || '';
      var variantId = btn.dataset.variantid || '';
      var price = Number(btn.dataset.price || 0);
      var title = btn.dataset.title || '';
      var isGiftCard = btn.dataset.isgiftcard === 'true';
      var isPackaging = btn.dataset.ispackaging === 'true';
      if (btn.classList.contains('decrement')) {
        quantity = Math.max(0, quantity - 1);
      } else {
        quantity = Math.min(max, quantity + 1);
      }
      var priceMoney = (price / 100).toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
      });
      this.dataQuantity = String(quantity);
      this.giftQuantity.textContent = String(quantity);
      this.giftQuantity.setAttribute('data-quantity', String(quantity));
      this.renderElementOnList(quantity, variantId, imgSrc, priceMoney, title, isGiftCard, isPackaging);
      this.calculateCosts();
    }
  }, {
    key: "renderElementOnList",
    value: function renderElementOnList(quantity, variantId, imgSrc, price, title, isGiftCard, isPackaging) {
      var _this6 = this;
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      var existingProductIndex = selectedProducts.findIndex(function (product) {
        return product.variantId === variantId;
      });
      if (quantity === 0 && existingProductIndex !== -1) {
        selectedProducts.splice(existingProductIndex, 1);
      } else {
        var newProduct = {
          quantity: quantity,
          variantId: variantId,
          imgSrc: imgSrc,
          price: price,
          title: title,
          isGiftCard: isGiftCard,
          isPackaging: isPackaging
        };
        if (existingProductIndex !== -1) {
          selectedProducts[existingProductIndex] = newProduct;
        } else {
          selectedProducts.push(newProduct);
        }
      }
      localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
      var existingProduct = this.list.querySelector("div[data-variantid=\"".concat(variantId, "\"]"));
      if (quantity === 0 && existingProduct) {
        this.list.removeChild(existingProduct);
      } else {
        if (!existingProduct) {
          var product = document.createElement('div');
          product.dataset.variantid = variantId;
          product.classList.add('selected-product');
          if (isGiftCard) {
            product.classList.add('is-gift-card');
          } else if (isPackaging) {
            product.classList.add('is-packaging');
          }
          product.innerHTML = "\n          <div class=\"selected-product-cc tw-flex tw-justify-between tw-items-center tw-w-full tw-border tw-border-solid tw-border-[#E0BD69] tw-rounded-[10px] tw-z-1 tw-relative tw-overflow-hidden\">\n            <div class=\"tw-w-full tw-h-[150px] tw-object-cover tw-max-h-[135px] tw-max-w-[135px] tw-relative tw-overflow-hidden\">\n              <img class=\"tw-inset-0 tw-w-full tw-h-full tw-object-cover\" src=\"".concat(imgSrc, "\" alt=\"").concat(title, "\" width=\"100%\" height=\"100%\">\n            </div>\n            <div class=\"tw-pr-[20px] tw-pl-[10px] tw-flex tw-justify-center tw-flex-col tw-items-end tw-gap-[0px] lg:tw-gap-[20px] tw-relative\">\n              <div class=\"tw-text-right\">").concat(title, "</div>\n              <div class=\"selected_btns_container tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center tw-gap-[10px] lg:tw-gap-[20px]\">\n                <div class=\"selected_btns_quantity tw-flex tw-items-center tw-order-2 lg:tw-order-1 tw-gap-[20px] lg:tw-gap-[20px] quantity_container\">\n                  <button class=\"quantity__button cc-decrement\" type=\"button\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" focusable=\"false\" class=\"icon icon-minus\" fill=\"none\" viewBox=\"0 0 10 2\">\n                      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z\" fill=\"currentColor\"></path>\n                    </svg>\n                  </button>\n                  <span class=\"gift_quantity tw-text-[16px]\">").concat(quantity, "</span>\n                  <button class=\"quantity__button cc-increment\" type=\"button\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" focusable=\"false\" class=\"icon icon-plus\" fill=\"none\" viewBox=\"0 0 10 10\">\n                      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z\" fill=\"currentColor\"></path>\n                    </svg>\n                  </button>\n                </div>\n                <div class=\"gift-card-edit tw-hidden tw-cursor-pointer tw-underline\">Redigere</div>\n                <div id=\"gift_product_remove\" class=\"lg:tw-order-1 tw-flex tw-justify-center tw-items-center tw-cursor-pointer\">\n                  <svg width=\"40\" height=\"41\" viewBox=\"0 0 40 41\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <mask id=\"path-1-inside-1_14_1392\" fill=\"white\">\n                      <path d=\"M0 0.5H40V40.5H0V0.5Z\"/>\n                    </mask>\n                    <path d=\"M39 0.5V40.5H41V0.5H39ZM1 40.5V0.5H-1V40.5H1Z\" fill=\"#CCCCCC\" mask=\"url(#path-1-inside-1_14_1392)\"/>\n                    <path d=\"M11.1099 13.3333H28.8876M24.4432 13.3333L24.1425 12.4312C23.8511 11.5569 23.7053 11.1198 23.4351 10.7966C23.1964 10.5113 22.89 10.2904 22.5438 10.1542C22.1516 10 21.691 10 20.7694 10H19.2281C18.3065 10 17.8459 10 17.4538 10.1542C17.1076 10.2904 16.8011 10.5113 16.5624 10.7966C16.2921 11.1198 16.1464 11.5569 15.855 12.4312L15.5543 13.3333M26.6654 13.3333V24.6667C26.6654 26.5336 26.6654 27.4669 26.3021 28.18C25.9825 28.8072 25.4726 29.3171 24.8454 29.6367C24.1323 30 23.199 30 21.3321 30H18.6654C16.7986 30 15.8652 30 15.1521 29.6367C14.5249 29.3171 14.015 28.8072 13.6954 28.18C13.3321 27.4669 13.3321 26.5336 13.3321 24.6667V13.3333M22.221 17.7778V25.5556M17.7765 17.7778V25.5556\" stroke=\"#343434\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                  </svg>\n                </div>\n                <div class=\"selected-product-price lg:tw-order-2 tw-text-right tw-font-semibold tw-flex tw-w-full tw-justify-end\" data-price=\"").concat(price, "\">").concat(price, "</div>\n              </div>\n            </div>\n          </div>\n        ");
          this.list.appendChild(product);
          var removeBtn = product.querySelector('#gift_product_remove');
          removeBtn.addEventListener('click', function () {
            _this6.removeProduct(variantId);
          });
          document.dispatchEvent(new CustomEvent('productAdded', {}));
          var productQuantityBtns = Array.from(product.querySelectorAll('.quantity__button'));
          productQuantityBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (btn.classList.contains('cc-increment')) {
                var quantityUp = document.querySelector(".quantity__button.cc-product.increment[data-variantid=\"".concat(variantId, "\"]"));
                quantityUp.click();
              } else if (btn.classList.contains('cc-decrement')) {
                var quantityDown = document.querySelector(".quantity__button.cc-product.decrement[data-variantid=\"".concat(variantId, "\"]"));
                quantityDown.click();
              }
            });
          });
        } else {
          var quantityElement = existingProduct.querySelector('.gift_quantity');
          quantityElement.textContent = String(quantity);
          document.dispatchEvent(new CustomEvent('productAdded', {}));
        }
      }
      this.calculateCosts();
      this.toggleModalsBasedOnPackaging();
    }
  }, {
    key: "toggleModalsBasedOnPackaging",
    value: function toggleModalsBasedOnPackaging() {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      var hasPackagingProduct = selectedProducts.some(function (product) {
        return product.isPackaging;
      });
      var add_to_cart_modal = document.querySelector('#add-to-cart-modal');
      var open_gift_card_modal = document.querySelector('#open-gift-card-modal');
      if (hasPackagingProduct) {
        add_to_cart_modal.classList.remove('tw-hidden');
        open_gift_card_modal.classList.add('tw-hidden');
      } else {
        add_to_cart_modal.classList.add('tw-hidden');
        open_gift_card_modal.classList.remove('tw-hidden');
      }
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(variantId) {
      var existingProduct = this.list.querySelector("div[data-variantid=\"".concat(variantId, "\"]"));
      if (existingProduct) {
        this.list.removeChild(existingProduct);
      }
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      selectedProducts = selectedProducts.filter(function (product) {
        return product.variantId !== variantId;
      });
      localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
      this.calculateCosts();
      this.toggleModalsBasedOnPackaging();
    }
  }, {
    key: "handleProductReadMore",
    value: function handleProductReadMore() {
      var allReadMoreModals = document.querySelectorAll('.read-more-modal');
      var readMoreModal = this.querySelector('.read-more-modal');
      allReadMoreModals.forEach(function (modal) {
        if (modal !== readMoreModal && modal.classList.contains('active')) {
          modal.classList.remove('active');
        }
      });
      if (readMoreModal.classList.contains('active')) {
        readMoreModal.classList.remove('active');
      } else {
        readMoreModal.classList.add('active');
      }
    }
  }, {
    key: "handleProductReadMoreAddToBasket",
    value: function handleProductReadMoreAddToBasket() {
      var readMoreAddToBasketButtons = this.querySelectorAll('.read-more-add-to-basket');
      readMoreAddToBasketButtons.forEach(function (readMoreAddToBasketBtn) {
        readMoreAddToBasketBtn.addEventListener('click', function () {
          var variantId = readMoreAddToBasketBtn.getAttribute('data-variantid') || '';
          var quantityUp = document.querySelector(".quantity__button.cc-product.increment[data-variantid=\"".concat(variantId, "\"]"));
          var readMoreModal = readMoreAddToBasketBtn.closest('.read-more-modal');
          if (quantityUp) {
            quantityUp.click();
          } else {
            console.error('Increment button not found for variant ID:', variantId);
          }
          if (readMoreModal && readMoreModal.classList.contains('active')) {
            readMoreModal.classList.remove('active');
          } else {
            console.error('Read-more modal not found or not active for variant:', variantId);
          }
        });
      });
    }
  }, {
    key: "calculateCosts",
    value: function calculateCosts() {
      var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
      var totalPriceMoneyEle = document.getElementById('total-price');
      var totalPriceExMoneyEle = document.getElementById('total-price-ex-tax');
      var totalPrice = 0;
      if (!selectedProducts || selectedProducts.length === 0) {
        totalPriceMoneyEle.textContent = '0,00 kr.';
        totalPriceExMoneyEle.textContent = '0,00 kr.';
        return;
      }
      selectedProducts.forEach(function (product) {
        var price = Number(product.price.replace(/[^0-9.-]+/g, ''));
        var quantity = Number(product.quantity);
        totalPrice += price * quantity;
      });
      if (totalPrice === 0) {
        totalPriceMoneyEle.textContent = '0,00 kr.';
        totalPriceExMoneyEle.textContent = '0,00 kr.';
      } else {
        var price = totalPrice / 100;
        var priceNoTax = price * 0.8;
        var totalPriceMoney = price.toLocaleString('da-DK', {
          style: 'currency',
          currency: 'DKK'
        });
        var totalPriceExTaxMoney = priceNoTax.toLocaleString('da-DK', {
          style: 'currency',
          currency: 'DKK'
        });
        totalPriceMoneyEle.textContent = totalPriceMoney;
        totalPriceExMoneyEle.textContent = totalPriceExTaxMoney;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/Edition-Gift-Basket/Edition-Packaging-Modal.ts":
/*!************************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-Packaging-Modal.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionPackagingModal)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionPackagingModal = /*#__PURE__*/function (_HTMLElement) {
  function EditionPackagingModal() {
    var _this;
    _classCallCheck(this, EditionPackagingModal);
    _this = _callSuper(this, EditionPackagingModal);
    _this.selectedVariantId = null;
    _this.bodyEle = document.querySelector('body');
    _this.selectedVariantDetails = {};
    _this.giftQuantity = 1;
    _this.packagingModal = document.getElementById('packaging_modal');
    _this.addToCartButton = document.getElementById('close_packaging_modal');
    _this.addToCartButton.disabled = true;
    return _this;
  }
  _inherits(EditionPackagingModal, _HTMLElement);
  return _createClass(EditionPackagingModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initializeProductItems();
      this.addToCartButton.addEventListener('click', function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var formattedPrice, eventDetail, gift_card, packaging, add_to_cart_modal, open_gift_card_modal;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (this.selectedVariantId) {
                  formattedPrice = (this.selectedVariantDetails.price / 100).toLocaleString('da-DK', {
                    style: 'currency',
                    currency: 'DKK'
                  });
                  eventDetail = {
                    variantId: this.selectedVariantId,
                    imgSrc: this.selectedVariantDetails.imgSrc || '',
                    price: formattedPrice,
                    isGiftCard: false,
                    isPackaging: true,
                    title: this.selectedVariantDetails.title || '',
                    quantity: 1
                  };
                  this.dispatchEvent(new CustomEvent('packagingSelected', {
                    detail: eventDetail,
                    bubbles: true,
                    composed: true
                  }));
                }
                gift_card = document.querySelector('#gift_card_modal');
                packaging = document.querySelector('#packaging_modal');
                gift_card.classList.add('tw-hidden');
                packaging.classList.add('tw-hidden');
                this.bodyEle.classList.remove('body_no_scroll');
                add_to_cart_modal = document.querySelector('#add-to-cart-modal');
                open_gift_card_modal = document.querySelector('#open-gift-card-modal');
                add_to_cart_modal.classList.remove('tw-hidden');
                open_gift_card_modal.classList.add('tw-hidden');
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
      });
    }
  }, {
    key: "initializeProductItems",
    value: function initializeProductItems() {
      var _this3 = this;
      var productItems = this.querySelectorAll('.packaging-item');
      productItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var _a;
          if (item.classList.contains('cc-selected-variant')) {
            item.classList.remove('cc-selected-variant');
            _this3.selectedVariantId = null;
            _this3.selectedVariantDetails = {};
          } else {
            productItems.forEach(function (i) {
              return i.classList.remove('cc-selected-variant');
            });
            item.classList.add('cc-selected-variant');
            _this3.selectedVariantId = item.getAttribute('data-variantid');
            _this3.selectedVariantDetails = {
              imgSrc: ((_a = item.querySelector('img')) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) || '',
              price: parseFloat(item.getAttribute('data-price') || '0'),
              title: item.getAttribute('data-title') || ''
            };
          }
          _this3.handleVariantSelection(_this3.selectedVariantId);
        });
      });
    }
  }, {
    key: "handleVariantSelection",
    value: function handleVariantSelection(variantId) {
      if (variantId) {
        this.addToCartButton.textContent = 'Fortsæt';
        this.addToCartButton.disabled = false;
      } else {
        this.addToCartButton.textContent = 'Vælg indpakning';
        this.addToCartButton.disabled = true;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/Edition-Gift-Basket/Edition-Reload-Sections.ts":
/*!************************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-Reload-Sections.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ReloadSections)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var ReloadSections = /*#__PURE__*/function () {
  function ReloadSections() {
    _classCallCheck(this, ReloadSections);
    this.reloadCart = this.reloadCart.bind(this);
    // this.reloadBasket = this.reloadBasket.bind(this);
    this.init = this.init.bind(this);
  }
  return _createClass(ReloadSections, [{
    key: "init",
    value: function init() {
      var _this = this;
      document.addEventListener('Edition:cart:reload', function () {
        console.log('reloading cart');
        _this.reloadCart();
      });
      document.addEventListener('Edition:basket:reload', function () {
        console.log('reloading basket');
        // this.reloadBasket();
      });
    }
  }, {
    key: "reloadCart",
    value: function reloadCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, responseText, fresh, miniCart;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return window.fetch("".concat(window.Shopify.routes.root_url, "?section_id=mini-cart"));
            case 3:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 15;
                break;
              }
              _context.next = 7;
              return response.text();
            case 7:
              responseText = _context.sent;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              miniCart = document.getElementById('cart');
              miniCart.innerHTML = fresh.innerHTML;
              console.log(fresh.innerHTML);
              _context.next = 16;
              break;
            case 15:
              console.log('Error in reloadCart:', response);
            case 16:
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.log('Error in reloadCart:', _context.t0);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 18]]);
      }));
    }
  }]);
}();


/***/ }),

/***/ "./src/Edition-Gift-Basket/Edition-add-to-card.ts":
/*!********************************************************!*\
  !*** ./src/Edition-Gift-Basket/Edition-add-to-card.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionAddToCart)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionAddToCart = /*#__PURE__*/function (_HTMLElement) {
  function EditionAddToCart() {
    var _this;
    _classCallCheck(this, EditionAddToCart);
    _this = _callSuper(this, EditionAddToCart);
    _this.giftQuantity = 1;
    _this.bodyEle = document.querySelector('body');
    _this.addToCartButton = document.getElementById('add-to-cart-modal');
    _this.giftQuantityDisplay = document.getElementById('gift_quantity_basket');
    _this.giftDecrementButton = document.getElementById('gift_decrement');
    _this.giftIncrementButton = document.getElementById('gift_increment');
    _this.giftQuantity = parseInt(_this.giftQuantityDisplay.getAttribute('data-quantity') || '1');
    return _this;
  }
  _inherits(EditionAddToCart, _HTMLElement);
  return _createClass(EditionAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.setupQuantityButtons();
      this.addToCartButton.addEventListener('click', function () {
        _this2.handleAddToCartButtonClick();
      });
    }
  }, {
    key: "setupQuantityButtons",
    value: function setupQuantityButtons() {
      var _this3 = this;
      var updateQuantityDisplay = function updateQuantityDisplay() {
        _this3.giftQuantityDisplay.textContent = _this3.giftQuantity.toString();
      };
      this.giftIncrementButton.addEventListener('click', function () {
        _this3.giftQuantity += 1;
        updateQuantityDisplay();
      });
      this.giftDecrementButton.addEventListener('click', function () {
        if (_this3.giftQuantity > 1) {
          _this3.giftQuantity -= 1;
          updateQuantityDisplay();
        }
      });
      updateQuantityDisplay();
    }
  }, {
    key: "addToCart",
    value: function addToCart(productDataToAddToCart) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, cart_icon;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-type': 'application/json'
                },
                body: JSON.stringify(productDataToAddToCart)
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                this.resetComponentState();
                document.dispatchEvent(new CustomEvent('Edition:cart:reload'));
                document.dispatchEvent(new CustomEvent('Edition:basket:reload'));
                cart_icon = document.querySelector('#cart-icon-bubble');
                cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.click();
              } else {
                console.error('Failed to add to cart:', response.statusText);
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error('Error adding to cart:', _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }, {
    key: "handleAddToCartButtonClick",
    value: function handleAddToCartButtonClick() {
      var productsInLocalStorage = JSON.parse(localStorage.getItem('selectedProducts')) || [];
      var giftCardMessage = localStorage.getItem('giftCardMessage');
      // Create an array to hold multiple product entries with unique 'gavekurvid'
      var itemsToAdd = [];
      var _loop = function _loop() {
        var randomNum = Math.floor(100000 + Math.random() * 900000); // New gavekurvid for each iteration
        // Add each product with unique gavekurvid but same giftcardmessage
        productsInLocalStorage.forEach(function (product) {
          itemsToAdd.push({
            id: product.variantId,
            quantity: product.quantity,
            properties: {
              gavekurvid: randomNum,
              giftcardmessage: giftCardMessage
            }
          });
        });
      };
      for (var i = 0; i < this.giftQuantity; i++) {
        _loop();
      }
      var productDataToAddToCart = {
        giftQuantity: this.giftQuantity,
        items: itemsToAdd
      };
      // Hide modals and add the products to the cart
      var gift_card = document.querySelector('#gift_card_modal');
      var packaging = document.querySelector('#packaging_modal');
      gift_card.classList.add('tw-hidden');
      packaging.classList.add('tw-hidden');
      this.bodyEle.classList.remove('body_no_scroll');
      var add_to_cart_modal = document.querySelector('#add-to-cart-modal');
      var open_gift_card_modal = document.querySelector('#open-gift-card-modal');
      add_to_cart_modal.classList.add('tw-hidden');
      open_gift_card_modal.classList.remove('tw-hidden');
      this.addToCart(productDataToAddToCart);
    }
  }, {
    key: "resetComponentState",
    value: function resetComponentState() {
      localStorage.removeItem('selectedProducts');
      localStorage.removeItem('giftCardMessage');
      var list = document.getElementById('selected-products');
      var giftQuantity = document.querySelector('.gift_quantity');
      var totalPriceMoneyEle = document.getElementById('total-price');
      var totalPriceExMoneyEle = document.getElementById('total-price-ex-tax');
      var giftQuantityDisplay = document.getElementById('gift_quantity_basket');
      var quantityElements = document.querySelectorAll('.gift_quantity');
      if (list) {
        list.innerHTML = '';
      }
      if (giftQuantity) {
        giftQuantity.textContent = '0';
        giftQuantityDisplay.setAttribute('data-quantity', '0');
        giftQuantityDisplay.textContent = '1';
      }
      if (totalPriceMoneyEle) {
        totalPriceMoneyEle.textContent = '0,00 kr';
      }
      if (totalPriceExMoneyEle) {
        totalPriceExMoneyEle.textContent = '0,00 kr';
      }
      quantityElements.forEach(function (element) {
        element.textContent = '0';
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Edition_Gift_Basket_Edition_Gift_Basket_Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-Gift-Basket-Modal */ "./src/Edition-Gift-Basket/Edition-Gift-Basket-Modal.ts");
/* harmony import */ var _Edition_Gift_Basket_Edition_Gift_Product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-Gift-Product */ "./src/Edition-Gift-Basket/Edition-Gift-Product.ts");
/* harmony import */ var _Edition_Gift_Basket_Edition_Gift_Card_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-Gift-Card-Modal */ "./src/Edition-Gift-Basket/Edition-Gift-Card-Modal.ts");
/* harmony import */ var _Edition_Gift_Basket_Edition_Packaging_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-Packaging-Modal */ "./src/Edition-Gift-Basket/Edition-Packaging-Modal.ts");
/* harmony import */ var _Edition_Gift_Basket_Edition_Reload_Sections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-Reload-Sections */ "./src/Edition-Gift-Basket/Edition-Reload-Sections.ts");
/* harmony import */ var _Edition_Gift_Basket_Edition_add_to_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Edition-Gift-Basket/Edition-add-to-card */ "./src/Edition-Gift-Basket/Edition-add-to-card.ts");






customElements.define('edition-gift-basket-modal', _Edition_Gift_Basket_Edition_Gift_Basket_Modal__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('edition-gift-product', _Edition_Gift_Basket_Edition_Gift_Product__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('edition-gift-card-modal', _Edition_Gift_Basket_Edition_Gift_Card_Modal__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('edition-packaging-modal', _Edition_Gift_Basket_Edition_Packaging_Modal__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define('edition-add-to-card', _Edition_Gift_Basket_Edition_add_to_card__WEBPACK_IMPORTED_MODULE_5__["default"]);
var reloadSections = new _Edition_Gift_Basket_Edition_Reload_Sections__WEBPACK_IMPORTED_MODULE_4__["default"]();
reloadSections.init();

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkinterpresent"] = self["webpackChunkinterpresent"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;